import { CalendarEvent } from 'mini-calendar-event-types';
import { getCalendarEventsStore } from '../../store/store';

/**
 * Gets calendar event by item id.
 * @param itemId - Item id of event.
 * @returns calendar event.
 */
export default function getCalendarEventByItemIdFromCache(itemId: string): CalendarEvent {
    return getCalendarEventsStore().getCalendarEvent(itemId);
}
